import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../common/components/form_container";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { QualidadeItemProcessosIndicadorForm, QualidadeItemProcessosIndicadorSchema } from "../../../schemas/CadastroProcessosRiscosItem/qualidade_processos_item_indicador";
import { IndicadoresDropDown } from "../../../../../../common/domain/models/indicadores_dropdown";

 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  ddlIndicadores: IndicadoresDropDown[];
  onClose: () => void;
  onSubmit: (e: QualidadeItemProcessosIndicadorForm) => void;
};

export const IndicadorModal = ({
  open, saving,loading,ddlIndicadores,
  onClose, onSubmit
}: Props) => {

  const hookForm = useForm<QualidadeItemProcessosIndicadorForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(QualidadeItemProcessosIndicadorSchema),
  });

  return (
    <>
      <BaseFormControlledModal
        width="800px" 
        open={open}
        saving={saving}
        loading={loading}
        title={'Cadastrar/Editar Indicador'}
        onClose={onClose}
        onSubmit={hookForm.handleSubmit(onSubmit)}>
          <FormContainer title={"Cadastrar/Editar Indicador"} arrangement="fullRow">
            <>
              <div className="flex flex-row items-center gap-4 w-full">
                <span className="whitespace-nowrap font-medium">
                  Selecione o Indicador:
                </span>
                <div className="flex-1">
                  <Controller
                    name="IdIndicador"
                    control={hookForm.control}
                    render={({ field: { onChange, value } }) => (
                      <DefaultMultiAutocomplete
                        label=""
                        placeholder="Selecione..."
                        value={ddlIndicadores.filter((option) =>
                          (value || []).includes(option.id)
                        )}
                        options={ddlIndicadores}
                        getOptionLabel={(x) => x.title}
                        getOptionKey={(x) => x.id}
                        onChange={(selectedOptions) => {
                          const ids = selectedOptions
                            ? selectedOptions.map((x) => x.id)
                            : [];
                          onChange(ids);
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </>
          </FormContainer>
      </BaseFormControlledModal>
    </>
  );
}